import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  useEffect(() => { api.get(`/blogs/${slug}`).then(({ data }) => setBlog(data)).catch(() => setBlog(false)); }, [slug]);
  if (blog === null) return <div className="min-h-[60vh] flex items-center justify-center text-neutral-500">Loading...</div>;
  if (blog === false) return <div className="min-h-[60vh] flex items-center justify-center">Article not found</div>;

  return (
    <div className="pt-12 pb-24">
      <div className="container-eq max-w-3xl">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-neutral-600 hover:text-black mb-6"><ArrowLeft className="w-4 h-4" /> All articles</Link>
        <div className="text-xs uppercase tracking-widest text-sky-500 font-semibold">{blog.category}</div>
        <h1 className="text-4xl sm:text-5xl font-display font-black tracking-tighter mt-2">{blog.title}</h1>
        <div className="mt-3 text-sm text-neutral-500">By {blog.author}</div>
        {blog.featured_image && <img src={blog.featured_image} alt={blog.title} className="mt-8 rounded-2xl aspect-[16/9] object-cover w-full" />}
        <article className="mt-8 prose prose-neutral max-w-none prose-headings:font-display prose-headings:tracking-tight prose-headings:font-bold prose-a:text-sky-600 prose-strong:text-neutral-900 prose-p:leading-relaxed" data-testid="blog-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{blog.content || ""}</ReactMarkdown>
        </article>
        {blog.tags?.length > 0 && (
          <div className="mt-10 flex flex-wrap gap-2">
            {blog.tags.map((t, i) => <span key={i} className="text-xs bg-neutral-100 rounded-full px-3 py-1">#{t}</span>)}
          </div>
        )}
      </div>
    </div>
  );
}
